import React from 'react';
import PropTypes from 'prop-types';
import {
  AppBar as MatAppBar,
  Toolbar as MatToolbar,
  Tab as MatTab
} from '@material-ui/core';
import { UiTabs } from './BsHeaderTab.style';

/**
 * 在這邊描述這個組件
 */

export const BsHeaderTab = ({
  data,
  activeIndex = 0,
  theme = 'default',
}) => {

  return (
    <MatAppBar
      component="div"
      color={theme}
      position="static"
      elevation={0}
    >
      <MatToolbar>
        <UiTabs value={activeIndex} textColor="inherit" indicatorTheme={theme}>
          {
            data.map(tab => (
              <MatTab
                key={tab.label}
                textColor="inherit"
                label={tab.label}
                onClick={tab.onClick}
              />
            )
            )
          }
        </UiTabs>
      </MatToolbar>
    </MatAppBar>
  );
};

BsHeaderTab.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string
    })
  ),
  activeIndex: PropTypes.number,
  theme: PropTypes.string,
};
